import { createContext } from "react";

export interface LinkType  {
    link: string | null,
    setLink: React.Dispatch<React.SetStateAction<string | null>>;
}
export const LocationContext = createContext<LinkType | undefined>(undefined );